module.exports = __webpack_public_path__ + "media/images/home/main/aa/backup/14-93826a38bf7a13abdd95a80b2c3da2b7.png";